import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { SectionTitle } from "@/components/GlassBits";
import { Plus, X } from "lucide-react";

export default function Branches() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", slug: "", logo: "", description: "", gstin: "" });

  const load = async () => setItems((await api.get("/admin/branches")).data);
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/branches", form);
      toast.success("Branch created");
      setOpen(false);
      setForm({ name: "", slug: "", logo: "", description: "", gstin: "" });
      load();
    } catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
  };

  return (
    <div>
      <SectionTitle eyebrow="Configuration" title="Branches / Categories"
        right={<button onClick={() => setOpen(true)} className="ldc-btn-primary px-4 py-2 rounded-md text-sm inline-flex items-center gap-2" data-testid="br-new"><Plus size={14}/> New branch</button>} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.length === 0 && <div className="ldc-glass p-8 text-center text-white/50 col-span-full">No branches yet. Create one to assign to payments.</div>}
        {items.map((b) => (
          <div key={b.id} className="ldc-glass p-5" data-testid={`br-card-${b.id}`}>
            <div className="flex items-start gap-3">
              {b.logo ? (
                <div className="p-2 bg-white/5 border border-white/10 rounded" style={{ minWidth: "80px", minHeight: "60px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <img src={b.logo} alt="" style={{ objectFit: "contain", width: "auto", height: "auto", maxWidth: "160px", maxHeight: "80px" }} />
                </div>
              ) : (
                <div className="w-14 h-14 rounded bg-[#fbce18]/10 border border-[#fbce18]/30 flex items-center justify-center text-[#fbce18] font-display font-semibold text-lg">{b.name?.[0]}</div>
              )}
              <div className="pt-1">
                <div className="font-display text-lg">{b.name}</div>
                <div className="text-xs text-white/40 font-mono">/{b.slug}</div>
              </div>
            </div>
            {b.description && <div className="mt-3 text-sm text-white/60">{b.description}</div>}
            {b.gstin && <div className="mt-2 text-xs text-white/40">GSTIN: <span className="text-white/70">{b.gstin}</span></div>}
          </div>
        ))}
      </div>

      {open && (
        <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <form onSubmit={submit} className="ldc-glass p-6 w-full max-w-md" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-display text-xl">New Branch</h3>
              <button type="button" onClick={() => setOpen(false)} className="p-1.5 rounded hover:bg-white/5"><X size={18}/></button>
            </div>
            <div className="space-y-3">
              <F label="Name" v={form.name} on={(v) => setForm({...form, name: v})} testid="br-input-name" required />
              <F label="Slug" v={form.slug} on={(v) => setForm({...form, slug: v.toLowerCase().replace(/\s+/g, "-")})} testid="br-input-slug" required />
              <F label="Logo URL" v={form.logo} on={(v) => setForm({...form, logo: v})} testid="br-input-logo" />
              <F label="GSTIN" v={form.gstin} on={(v) => setForm({...form, gstin: v})} testid="br-input-gstin" />
              <label className="block">
                <div className="text-[10px] tracking-[0.24em] uppercase text-white/40 mb-1.5">Description</div>
                <textarea value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} rows={2} className="ldc-input w-full rounded-md px-3 py-2 text-sm" data-testid="br-input-desc" />
              </label>
            </div>
            <div className="flex justify-end gap-2 mt-5">
              <button type="button" onClick={() => setOpen(false)} className="px-4 py-2 rounded-md border border-white/10 text-sm">Cancel</button>
              <button type="submit" className="ldc-btn-primary px-5 py-2 rounded-md text-sm" data-testid="br-submit">Create</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
function F({ label, v, on, testid, required }) {
  return (
    <label className="block">
      <div className="text-[10px] tracking-[0.24em] uppercase text-white/40 mb-1.5">{label}</div>
      <input value={v} onChange={(e) => on(e.target.value)} required={required} className="ldc-input w-full rounded-md px-3 py-2 text-sm" data-testid={testid} />
    </label>
  );
}
